module.exports = __webpack_public_path__ + "img/a_tool_4_active.d135ab5f.png";